// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_g2TL1","points":"points_MeDbz","primary":"primary_LwvWp","reverse":"reverse_LMZeQ"};